module.exports = __webpack_public_path__ + "media/main.aeaac802.mp4";